import { IAPIAction } from "interfaces";
import { EditorHome } from "constants/Actions";

const {
  GET_ALL_TEXT_DATA,
  GET_ALL_TEXT_DATA_SUCCESS,
  GET_ALL_TEXT_DATA_FAIL,

  GET_ALL_TEMPLATE_RULES,
  GET_ALL_TEMPLATE_RULES_SUCCESS,
  GET_ALL_TEMPLATE_RULES_FAIL,

  GET_DATA_ADAPTERS,
  GET_DATA_ADAPTERS_SUCCESS,
  GET_DATA_ADAPTERS_FAIL,

  SAVE_TEMPLATE_CATEGORY,
  SAVE_TEMPLATE_CATEGORY_SUCCESS,
  SAVE_TEMPLATE_CATEGORY_FAIL,

  HANDLE_ADD_CATEGORY_DRAWER,

  UPDATE_CATEGORY_DISPLAY_NAME,
  UPDATE_CATEGORY_DISPLAY_NAME_SUCCESS,
  UPDATE_CATEGORY_DISPLAY_NAME_FAIL,

  GET_CATEGORY_DETAILS,
  GET_CATEGORY_DETAILS_SUCCESS,
  GET_CATEGORY_DETAILS_FAIL,

  GET_ALL_SETTINGS,
  GET_ALL_SETTINGS_SUCCESS,
  GET_ALL_SETTINGS_FAIL,

  UPDATE_SETTINGS,

  ADD_REMOVE_FROM_MESSAGE_TEMPLATES,
  ADD_REMOVE_FROM_MESSAGE_TEMPLATES_SUCCESS,
  ADD_REMOVE_FROM_MESSAGE_TEMPLATES_FAIL,
} = EditorHome;

export const editorHome: Readonly<IAPIAction> = {
  templateRules: {
    get: (data) => ({
      type: GET_ALL_TEMPLATE_RULES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_ALL_TEMPLATE_RULES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_ALL_TEMPLATE_RULES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  texts: {
    get: (data) => ({
      type: GET_ALL_TEXT_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_ALL_TEXT_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_ALL_TEXT_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  dataAdapterList: {
    get: (data) => ({
      type: GET_DATA_ADAPTERS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DATA_ADAPTERS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DATA_ADAPTERS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  templateCategory: {
    save: (data) => ({
      type: SAVE_TEMPLATE_CATEGORY,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SAVE_TEMPLATE_CATEGORY_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SAVE_TEMPLATE_CATEGORY_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    openDrawer: (data) => ({
      type: HANDLE_ADD_CATEGORY_DRAWER,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  settings: {
    get: (data) => ({
      type: GET_ALL_SETTINGS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    update: (data) => ({
      type: UPDATE_SETTINGS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_ALL_SETTINGS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_ALL_SETTINGS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  categoryDisplayName: {
    update: (data) => ({
      type: UPDATE_CATEGORY_DISPLAY_NAME,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: UPDATE_CATEGORY_DISPLAY_NAME_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: UPDATE_CATEGORY_DISPLAY_NAME_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  categoryDetails: {
    get: (data) => ({
      type: GET_CATEGORY_DETAILS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_CATEGORY_DETAILS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_CATEGORY_DETAILS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  messageTemplates: {
    save: (data) => ({
      type: ADD_REMOVE_FROM_MESSAGE_TEMPLATES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ADD_REMOVE_FROM_MESSAGE_TEMPLATES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ADD_REMOVE_FROM_MESSAGE_TEMPLATES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
